import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { useSafeImage } from '../../hooks/useSafeImage/useSafeImage';
import { useStyles } from '../../hooks/useStyles/useStyles';
import { ErrorBoundary } from '../../provider/errorBoundary/errorBoundary';
import { FallbackComponent } from '../../provider/errorBoundary/fallbackComponent';
import { IconHighlightedStandAlone } from './iconHighlightedStandAlone';
// eslint-disable-next-line react/display-name
const IconHighlightedComponent = React.forwardRef(({ ctv, image, ...props }, ref) => {
    const urlImage = useSafeImage({ image: image?.image, fallbackImage: image?.fallbackImage });
    const variantStyles = useStyles(STYLES_NAME.ICON_HIGHLIGHTED, props.variant, ctv);
    return (_jsx(IconHighlightedStandAlone, { ...props, ref: ref, ariaLabelImage: image?.['aria-label'], styles: variantStyles, urlImage: urlImage }));
});
const IconHighlightedBoundary = (props, ref) => (_jsx(ErrorBoundary, { fallBackComponent: _jsx(FallbackComponent, { children: _jsx(IconHighlightedStandAlone, { ...props, ref: ref }) }), children: _jsx(IconHighlightedComponent, { ...props, ref: ref }) }));
/**
 * @deprecated
 * This component is deprecated and will be removed in future versions.
 */
const IconHighlighted = React.forwardRef(IconHighlightedBoundary);
export { IconHighlighted };
//# sourceMappingURL=iconHighlighted.js.map